import {isDetailsMode, useFormMode} from "@contexts/FormModeContext";
import Link from "next/link";

const SubmissionDetailsHeadingBlock = ({
   formData,
   editUrl,
   listUrl
}) => {
   
   const {mode} = useFormMode();
   
   if (!isDetailsMode(mode)) {
      return null;
   }
   
   const isTrashed = formData.deleted_at && formData.deleted_at !== '-';
   
   return (
      <div className="submission-details-heading-block bottom-border mb-4">
         
         <div className="row mb-3">
            <div className="col-12 text-center d-flex justify-content-center align-items-center gap-3">
               
               {!isTrashed && (
                  <Link
                     href={editUrl}
                     className="btn btn-success"
                  >
                     <i className="fa fa-pencil"></i> Edit Application
                  </Link>
               )}
               
               
               <Link
                  href={listUrl}
                  className="btn btn-info"
               >
                  <i className="fa fa-list"></i> Application List
               </Link>
               
            </div>
         </div>
         
         <div className="row">
            
            <div className="col-12 col-md-3">
               <label className="form-label m-0">Submission ID</label>
               <div className="form-text m-0">
                  {formData.id}
                  
               </div>
            </div>
            
            <div className="col-12 col-md-3">
               <label className="form-label m-0">Submission Date</label>
               <div className="form-text m-0">
                  {formData.created_at_diff} <br />
                  @ {formData.created_at}
               </div>
            </div>
            
            <div className="col-12 col-md-3">
               <label className="form-label m-0">Last Update Date</label>
               <div className="form-text m-0">
                  
                  {(formData.updated_at && formData.updated_at !== '-' && (formData.updated_at !== formData.created_at)) ? (
                     <>
                        {formData.updated_at_diff} <br />
                        @ {formData.updated_at}
                     </>
                  ) : (
                     <>
                        -
                     </>
                  )}
               
               
               </div>
            </div>
            
            <div className="col-12 col-md-3">
               <label className="form-label m-0">Status</label>
               <div className="form-text m-0">
                  
                  {isTrashed ? (
                     <>
                        <span className="text-danger">Trashed</span><br/>
                        @ {formData.deleted_at}
                     </>
                  ) : (
                     <>
                        <span className="text-success">Active</span>
                     </>
                  )}
               
               
               </div>
            </div>
         
         </div>
      </div>
   )
      ;
   
}
export default SubmissionDetailsHeadingBlock;